(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  (() => {
    const dock = document.querySelector('.ansably-footer-widget-space');
    if (!dock) return;
    const footer = dock.closest('footer');
    const root = document.documentElement;
    const mobile = window.matchMedia('(max-width: 767px)');
    let pending = false;
    const update = () => {
      pending = false;
      const hasControls = Boolean(document.querySelector('#ba-loy-container #launcher-wrapper, shopify-chat'));
      root.classList.toggle('ansably-has-footer-widgets', hasControls);
      const bounds = (footer.querySelector('.ansably-footer-instalments') || footer).getBoundingClientRect();
      const docked = mobile.matches && hasControls && bounds.top < window.innerHeight && footer.getBoundingClientRect().bottom > 0;
      root.classList.toggle('ansably-footer-widgets-docked', docked);
      if (docked) {
        root.style.setProperty('--ansably-footer-widget-top', `${Math.round(dock.getBoundingClientRect().top + 16)}px`);
      } else {
        root.style.removeProperty('--ansably-footer-widget-top');
      }
      const chat = document.querySelector('shopify-chat');
      const chatRoot = chat?.shadowRoot;
      const chatButton = chatRoot?.querySelector('[part~="activator"]') ||
        chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="activator"]');
      if (mobile.matches && chatButton && !chat.hasAttribute('open')) {
        const translation = getComputedStyle(chatButton).translate.split(' ');
        const chatBounds = chatButton.getBoundingClientRect();
        const originalTop = chatBounds.top - (parseFloat(translation[1]) || 0);
        const originalLeft = chatBounds.left - (parseFloat(translation[0]) || 0);
        const targetTop = docked ? dock.getBoundingClientRect().top + 16 : window.innerHeight - 12 - chatBounds.height;
        root.style.setProperty('--ansably-footer-chat-shift', `${Math.round(targetTop - originalTop)}px`);
        root.style.setProperty('--ansably-footer-chat-inline-shift', `${Math.round(window.innerWidth - 12 - chatBounds.width - originalLeft)}px`);
      } else {
        root.style.removeProperty('--ansably-footer-chat-shift');
        root.style.removeProperty('--ansably-footer-chat-inline-shift');
      }
    };
    const schedule = () => {
      if (!pending) {
        pending = true;
        window.requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    mobile.addEventListener('change', schedule);
    new ResizeObserver(schedule).observe(footer);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'shell-ready'] });
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
